module.exports = __webpack_public_path__ + "static/media/fire-extinguisher.60408f6d.svg";